import { BikeIcon } from './bike'
import { BuildingIcon } from './building'
import { CarIcon } from './car'
import { ConstructionIcon } from './construction'
import { HouseIcon } from './house'
import { MapIcon } from './map'
import { TruckIcon } from './truck'

export { BikeIcon, BuildingIcon, CarIcon, ConstructionIcon, HouseIcon, MapIcon, TruckIcon }
